import { withAuthorization } from "../../../authentication/Session/withAuthorization";
import { getAuthorizationGuard } from "../../../authentication/authorizations";
import { Role } from "@farmact/model/src/model/Role";
import { lazy } from "react";
import { DefaultPage } from "../../../structure/Page/DefaultPage/DefaultPage";

const CreditNotesPageContent = lazy(() => import("./CreditNotesPageContent"));

function CreditNotesPageInternal() {
    return (
        <DefaultPage>
            <CreditNotesPageContent />
        </DefaultPage>
    );
}

export const CreditNotesPage = withAuthorization(getAuthorizationGuard(Role.OWNER, Role.ADMIN))(
    CreditNotesPageInternal
);
